import styles from './DidYouMean.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { didYouMeanClicked } from 'store/search/search';
import QualifiedLink from 'QualifiedLink/QualifiedLink';

function mapDispatchToProps(dispatch) {
  return {
    onClick: () => dispatch(didYouMeanClicked())
  };
}

@connect(null, mapDispatchToProps)
export default class DidYouMean extends Component {

  static propTypes = {
    locations: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired
  };

  render() {
    const { locations } = this.props;

    return (
      <p className={styles.root} data-automation="didYouMean">
        <span className={styles.didYouMean}>{'Did you mean '}</span>
        <span className={styles.suggestions}>
          {
            locations.map((location, index) =>
              <span className={styles.locationWrapper} key={index}>
                <QualifiedLink
                  className={styles.location}
                  path="/jobs"
                  onClick={this.props.onClick}
                  params={location.refineParams}
                  data-automation={`didYouMeanLocation${index}`}>
                  {location.label}
                </QualifiedLink>
                {
                  index < locations.length - 1 &&
                    <span className={styles.or}> or </span>
                }
              </span>
            )
          }
        </span>
      </p>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/DidYouMean/DidYouMean.js
 **/